import styled from "styled-components";

export const ErrorBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
	z-index: 10000;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const ErrorContainer = styled.div`
	background-color: #fff;
	padding: 20px;
	width: 70%;
	max-width: 400px;
	border-radius: 8px;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
	text-align: center;
`;

export const ErrorMessage = styled.p`
	color: #d9534f;
	font-size: 16px;
	margin-bottom: 20px;
`;

export const CloseButton = styled.button`
	background-color: #d9534f;
	color: #fff;
	border: none;
	padding: 10px 20px;
	border-radius: 5px;
	cursor: pointer;
	font-size: 16px;

	&:hover {
		background-color: #c9302c;
	}
`;